


























import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class HdrLeftNav extends Vue {
  @Prop()
  private cState: any;
}
